<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card :disabling="dataUpdating">
          <div class="shadow-none">
            <div
              class="d-flex justify-space-between flex-wrap align-center"
            >
              <v-card-title>
                SotalCloud Instance: {{ operator.extId }}
              </v-card-title>
              <div class="pa-2">
                <v-btn
                  :disabled="scanning"
                  color="orange"
                  @click="scanOperator(operator.id)"
                >
                  <i class="mdi mdi-sync p-r-5"/>
                  RE-SCAN
                </v-btn>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-space-between align-center flex-wrap m-3"
          >
            <div class="flex-1 mr-4 ml-4">
              <p class="ma-0">
                <a
                  href="#"
                  class="font-weight-medium grey--text "
                >
                  <v-icon
                    class="text-body-1"
                    color="danger"
                  >mdi-account
                  </v-icon>
                  SotalCloud Admin
                </a>
              </p>
              <p class="ma-0">
                {{ operator.adminUsername }}
              </p>
            </div>
            <div class="flex-1">
              <div class="d-flex justify-space-between">
                <p class="ma-0">
                  Distrib Package:
                  <a
                    v-if="operator.distributionPackage"
                    :href="'/distributions/' + operator.distributionPackage.id"
                    class="font-weight-medium"
                    target="_blank"
                  >
                    {{ operator.distributionPackage.name }} <span
                    v-if="distribChannels.length">({{ distribChannels.length }})</span>
                  </a>
                </p>
              </div>
            </div>
            <div class="flex-1 text-right px-6">
              <p class="ma-0">
                <a
                  href="#"
                  class="font-weight-medium grey--text "
                >
                  <v-icon
                    class="text-body-1"
                    color="danger"
                  >mdi-package
                  </v-icon>
                  SotalCloud Package ID
                </a>
              </p>
              <p class="ma-0">
                {{ operator.scPackageId }}
              </p>
            </div>
          </div>
          <v-card-text>
            <v-container
              v-if="scanning"
              style="height: 300px;"
            >
              <v-row
                class="fill-height"
                align-content="center"
                justify="center"
              >
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Scanning...
                </v-col>
                <v-col cols="6">
                  <v-progress-linear
                    color="primary accent-4"
                    indeterminate
                    rounded
                    height="6"
                  />
                </v-col>
              </v-row>
            </v-container>

            <v-tabs v-if="!scanning">
              <v-tab>
                <v-icon left>
                  mdi-checkbox-marked-circle
                </v-icon>
                Added Channels ({{ linkedChannels.length }})
              </v-tab>
              <v-tab>
                <v-icon left>
                  mdi-bell-plus
                </v-icon>
                Missed channels ({{ newChannels.length }})
              </v-tab>
              <v-tab>
                <v-icon left>
                  mdi-view-list
                </v-icon>
                Extra channels ({{ extraChannels.length }})
              </v-tab>

              <v-tab-item>
                <v-data-table
                  v-if="!scanning"
                  :headers="linkedChannelsHeaders"
                  :items="linkedChannels"
                  item-key="id"
                  class="elevation-1 table-one pointer"
                  multi-sort
                  :items-per-page="300"
                  :footer-props="{
                    'items-per-page-options': [300, 600],
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                  }"
                >
                  <template v-slot:item.id="{index}">
                    <div class="d-flex align-center">
                      <p class="ma-0 font-weight-medium">
                        {{ index + 1 }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.name="{item}">
                    <div
                      class="d-flex align-center"
                    >
                      <v-avatar
                        class="mr-2"
                        size="26"
                        dark
                        tile
                      >
                        <img
                          :src="item.scAsset.LogoURL"
                          style="background-color: grey"
                          alt=""
                        >
                      </v-avatar>
                      <p class="ma-0 font-weight-medium">
                        <v-icon
                          v-if="item.thirdPartyChannelId > 0"
                          class="mr-1"
                        >
                          mdi-numeric-3-box-outline
                        </v-icon>
                        {{ item.name }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.state="{item}">
                    <v-chip
                      v-if="item.scAsset.Status !== 'innactive'"
                      color="light-green lighten-5"
                      small
                    >
                      <v-icon class=" text-caption mr-1 ">
                        mdi-check
                      </v-icon>
                      active
                    </v-chip>
                    <v-chip
                      v-if="item.scAsset.Status === 'innactive'"
                      color="red lighten-5"
                      small
                    >
                      <v-icon class=" text-caption mr-1 ">
                        mdi-check
                      </v-icon>
                      inactive
                    </v-chip>
                    /

                    <v-chip
                      v-if="item.thirdPartyChannelId > 0"
                      color="light-green lighten-5"
                      small
                    >
                      <v-icon class=" text-caption mr-1 ">
                        mdi-check
                      </v-icon>
                      active
                    </v-chip>
                    <v-chip
                      v-if="item.playoutChannelId > 0 && item.asset.Status !== 'innactive'"
                      color="light-green lighten-5"
                      small
                    >
                      <v-icon class=" text-caption mr-1 ">
                        mdi-check
                      </v-icon>
                      active
                    </v-chip>
                    <v-chip
                      v-if="item.playoutChannelId > 0 && item.asset.Status === 'innactive'"
                      color="red lighten-5"
                      small
                    >
                      <v-icon class=" text-caption mr-1 ">
                        mdi-check
                      </v-icon>
                      inactive
                    </v-chip>
                  </template>
                  <template v-slot:item.compareResult="{item}">
                    <a
                      v-if="item.compareResult.length > 0"
                      href="#"
                      @click.prevent="openComparisonResultDialog(item, true)"
                    >
                      <div class="d-flex align-center">
                        <v-icon
                          class="text--darken-1 mr-2 red--text"
                        >
                          mdi-compare
                        </v-icon>
                        <div class="font-weight-medium text-no-wrap">
                          <span>
                            {{ item.compareResult.length }}
                            <span>diffs</span>
                          </span>
                        </div>
                      </div>
                    </a>

                    <div
                      v-if="item.compareResult.length === 0"
                      class="d-flex align-center"
                    >
                      <v-icon
                        class="text--darken-1 mr-2 green--text"
                      >
                        mdi-compare
                      </v-icon>
                      <div class="font-weight-medium text-no-wrap">
                        <span>
                          synced
                        </span>
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.external="{item}">
                    <span
                      v-if="item.external"
                      class="text-no-wrap"
                    >
                      <v-icon class="success--text text-body-2">
                        mdi-check
                      </v-icon>
                    </span>
                  </template>
                  <template v-slot:item.url="{item}">
                    <v-btn
                      v-if="item.url && item.selected"
                      text
                      color="primary"
                      @click.stop="openPlayer(item)"
                    >
                      <v-icon>
                        mdi-play
                      </v-icon>
                      Play
                    </v-btn>
                    <template v-else-if="!item.selected">
                      <v-chip
                        class=""
                        color="red"
                        label
                        small
                        text-color="white"
                      >
                        <v-icon
                          small
                          left
                        >
                          mdi-minus
                        </v-icon>
                        removing
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip
                        class=""
                        color="orange"
                        label
                        small
                        text-color="white"
                      >
                        <v-icon
                          small
                          left
                          class="fa-spin"
                        >
                          fa fa-circle-notch
                        </v-icon>
                        processing
                      </v-chip>
                    </template>
                  </template>
                  <template v-slot:item.createTime="{item}">
                    {{ moment.utc(item.createTime).format('D MMM YYYY') }}
                  </template>
                  <template v-slot:item.lcn="{ item }">
                    <v-text-field
                      v-model="item.scAsset.LCN"
                      hide-details
                      dense
                      outlined
                      style="max-width: 70px;"
                      color="primary"
                      background-color="#eee"
                      @focusout="updateLCN(item)"
                    />
                  </template>
                  <template v-slot:item.preroll="{ item }">
                    <v-checkbox
                      v-model="item.preroll"
                      hide-details
                      dense
                      color="success"
                      @click="savePreroll(item)"
                    />
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  v-if="!scanning"
                  :headers="newChannelsHeaders"
                  :items="newChannels"
                  item-key="id"
                  class="elevation-1 table-one pointer"
                  multi-sort
                  :items-per-page="300"
                  :footer-props="{
                    'items-per-page-options': [300, 600],
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                  }"
                >
                  <template v-slot:item.id="{index}">
                    <div class="d-flex align-center">
                      <p class="ma-0 font-weight-medium">
                        {{ index + 1 }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.name="{item}">
                    <div
                      class="d-flex align-center"
                    >
                      <v-avatar
                        class="mr-2"
                        size="26"
                        dark
                        tile
                      >
                        <img
                          :src="item.logoURL"
                          style="background-color: grey"
                          alt=""
                        >
                      </v-avatar>
                      <p class="ma-0 font-weight-medium">
                        <v-icon
                          v-if="item.external"
                          class="mr-1"
                        >
                          mdi-numeric-3-box-outline
                        </v-icon>
                        {{ item.channelName }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.action="{item}">
                    <div
                      class="float-right"
                    >
                      <v-btn
                        depressed
                        small
                        class="success success--text lighten-5"
                        @click="addChannel(item)"
                      >Add Channel to SC
                      </v-btn
                      >
                    </div>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  v-if="!scanning"
                  :headers="extraChannelsHeaders"
                  :items="extraChannels"
                  item-key="id"
                  class="elevation-1 table-one pointer"
                  multi-sort
                  :items-per-page="300"
                  :footer-props="{
                    'items-per-page-options': [300, 600],
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                  }"
                >
                  <template v-slot:item.id="{index}">
                    <div class="d-flex align-center">
                      <p class="ma-0 font-weight-medium">
                        {{ index + 1 }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.name="{item}">
                    <div
                      class="d-flex align-center"
                    >
                      <v-avatar
                        class="mr-2"
                        size="26"
                        dark
                        tile
                      >
                        <img
                          :src="item.scAsset.LogoURL"
                          style="background-color: grey"
                          alt=""
                        >
                      </v-avatar>
                      <p class="ma-0 font-weight-medium">
                        <v-icon
                          v-if="item.thirdPartyChannelId > 0"
                          class="mr-1"
                        >
                          mdi-numeric-3-box-outline
                        </v-icon>
                        {{ item.name }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:item.state="{item}">
                    <v-chip
                      v-if="item.scAsset.Status !== 'innactive'"
                      color="light-green lighten-5"
                      small
                    >
                      <v-icon class="text-caption mr-1">
                        mdi-check
                      </v-icon>
                      active
                    </v-chip>
                    <v-btn
                      v-if="item.scAsset.Status !== 'innactive'"
                      depressed
                      class="ml-2"
                      x-small
                      @click="disableAsset(item)"
                    >disable
                    </v-btn
                    >
                    <v-chip
                      v-if="item.scAsset.Status === 'innactive'"
                      color="red lighten-5"
                      small
                    >
                      <v-icon class="text-caption mr-1">
                        mdi-check
                      </v-icon>
                      inactive
                    </v-chip>
                    <v-btn
                      v-if="item.scAsset.Status === 'innactive'"
                      depressed
                      class="ml-2"
                      x-small
                      @click="enableAsset(item)"
                    >enable
                    </v-btn
                    >
                  </template>
                  <template v-slot:item.lcn="{ item }">
                    <v-text-field
                      v-model="item.scAsset.LCN"
                      hide-details
                      dense
                      outlined
                      style="max-width: 70px;"
                      color="primary"
                      background-color="#eee"
                      @focusout="updateLCN(item)"
                    />
                  </template>
                  <template v-slot:item.compareResult="{item}">
                    <a
                      v-if="item.compareResult.length > 0"
                      href="#"
                      @click.prevent="openComparisonResultDialog(item, false)"
                    >
                      <div class="d-flex align-center">
                        <v-icon
                          v-if="item.thirdPartyChannelId > 0 || item.playoutChannelId > 0"
                          class="text--darken-1 mr-2 red--text"
                        >
                          mdi-compare
                        </v-icon>
                        <div class="font-weight-medium text-no-wrap">
                          <span>
                            {{ item.compareResult.length }}
                            <span>fields</span>
                          </span>
                        </div>
                      </div>
                    </a>
                  </template>
                  <template v-slot:item.external="{item}">
                    <span
                      v-if="item.external"
                      class="text-no-wrap"
                    >
                      <v-icon class="success--text text-body-2">
                        mdi-check
                      </v-icon>
                    </span>
                  </template>
                  <template v-slot:item.remap="{item}">
                    <div
                      v-if="item.scAsset.StreamURL.startsWith('https://distrib.noisypeak.com/d/')"
                      style="color: #c03d35"
                    >
                      <v-icon
                        small
                        color="#c03d35"
                      >
                        mdi-alert
                      </v-icon>
                      reassign ?
                    </div>
                  </template>

                  <template v-slot:item.stream="{item}">
                    <v-btn
                      v-if="item.scAsset.StreamURL"
                      class="mx-2 shadow-none orange darken-1"
                      fab
                      dark
                      x-small
                      @click.stop="openPlayer(item.id, item.scAsset.StreamURL, item.scAsset.Name)"
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.preroll="{ item }">
                    <v-checkbox
                      v-model="item.preroll"
                      hide-details
                      dense
                      color="success"
                      @click="savePreroll(item)"
                    />
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Add Form  -->
    <v-dialog
      v-model="comparisonResultDialog"
      max-width="1024px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Channel: {{ comparisonResultTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <table class="table compare-table">
                  <tbody>
                  <tr>
                    <td class="primary--text">
                      Field
                    </td>
                    <td class="primary--text">
                      SotalCloud Value
                    </td>
                    <td
                      v-if="comparisonDisplay3Column"
                      class="primary--text"
                    >
                      Playout value
                    </td>
                  </tr>
                  <tr
                    v-for="cr in compareResults"
                    :key="cr.field"
                  >
                    <td
                      style="width: 20%; min-width: 140px;"
                    >
                      {{ cr.field }}
                      <a
                        v-if="cr.field === 'catchup URL'"
                        href="#"
                        @click.prevent="patchOperatorCatchupURL(cr.playout_value)"
                      >patch</a>
                    </td>
                    <td style="width: 40%; word-break: break-all;">
                        <span v-if="cr.field === 'XMLTV URL' && cr.sc_value">
                          <a
                            :href="cr.sc_value"
                            target="_blank"
                          >
                            {{ cr.sc_value }}
                          </a>
                        </span>
                      <div v-else>
                        {{ cr.sc_value || 'n/a' }}
                      </div>
                      <span v-if="cr.field === 'logo'">
                          <img
                            :src="cr.sc_value"
                            class="mr-2"
                            style="background-color: grey; width: 256px;"
                            alt=""
                          >
                        </span>
                      <v-btn
                        v-if="comparisonDisplay3Column"
                        depressed
                        x-small
                        class="primary primary--text lighten-5"
                        @click="updateAsset(cr.field, cr.playout_value)"
                      >Sync with Playout
                      </v-btn
                      >
                    </td>
                    <td
                      v-if="comparisonDisplay3Column"
                      style="width: 40%; word-break: break-all; background-color: #fff7d9"
                    >
                        <span v-if="cr.field === 'XMLTV URL' && cr.playout_value">
                          <a
                            :href="cr.playout_value"
                            target="_blank"
                          >
                            {{ cr.playout_value }}
                          </a>
                        </span>
                      <div v-else>
                        {{ cr.playout_value || 'n/a' }}
                      </div>
                      <span v-if="cr.field === 'logo'">
                          <img
                            :src="cr.playout_value"
                            style="background-color: grey; width: 256px;"
                            alt=""
                          >
                          <v-btn
                            x-small
                            class="primary primary--text lighten-5"
                            @click="openLogoDialog(cr.sc_value)"
                          >Upldate PLAYOUT by using Sotalcloud Logo</v-btn
                          >
                        </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="blue darken-1"
            text
            @click="comparisonResultDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-r-20">
                {{ playerTitle }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ playerStream }}
              </v-list-item-subtitle>
              <div
                v-if="newChannels.length"
                class="d-flex justify-space-between pt-8"
              >
                <v-autocomplete
                  v-model="reassignTo"
                  :items="newChannels"
                  item-text="channelName"
                  clearable
                  return-object
                  outlined
                  dense
                  label="Reassing this channel to a missed channel from the Distrib package..."
                  style="width: 300px;"
                />
                <v-btn
                  text
                  color="primary"
                  @click.stop="reassign()"
                >
                  <v-icon>
                    mdi-inbox-arrow-down
                  </v-icon>
                  Re-assign
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Logo Update Dialog -->
    <v-dialog
      v-model="logoConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Update Playout channel?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to update the Playout channel logo?!
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            depressed
            text
            @click="logoConfirmDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="primary"
            @click="updatePlayoutLogo()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  processDistributionPackage,
  processSCAsset,
  processSCOperator,
  processThirdPartyChannel
} from '@/store/converters'
import moment from 'moment-timezone'

export default {
  metaInfo: {
    title: 'SC Operator',
  },
  data() {
    return {
      linkedChannelsHeaders: [
        {
          text: '№',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {text: 'Channel', value: 'name'},
        {text: 'Channel State in SotalCloud / in Playout', value: 'state', sortable: false},
        {text: 'SC LCN', value: 'lcn', sortable: false},
        {text: 'Data differences', value: 'compareResult', sortable: false},
        {
          text: '',
          sortable: false,
          value: 'action',
        },
      ],
      newChannelsHeaders: [
        {
          text: '№',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {text: 'Channel', value: 'name'},
        {
          text: 'Actions',
          sortable: false,
          value: 'action',
        },
      ],
      extraChannelsHeaders: [
        {
          text: '№',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {text: 'Channel', value: 'name'},
        {text: 'Channel State in SotalCloud', value: 'state', sortable: false},
        {text: 'SC LCN', value: 'lcn', sortable: false},
        {text: '', value: 'remap', sortable: false},
        {text: 'Stream', value: 'stream', sortable: false},
        {text: 'Data', value: 'compareResult', sortable: false},
        {
          text: '',
          sortable: false,
          value: 'action',
        },
      ],
      assets: [],
      distributionPackages: [],
      newPackageDialog: false,
      newDistribPack: {
        name: '',
        mtPrefix: '',
        mtPrerollPrefix: '',
      },
      rules: {
        nameRules: [
          (v) => !!v || 'Name is required',
          (v) => (v && v.length <= 1024) || 'Name must be less than 1024 characters',
        ],
      },
      deletedDistribPack: {},
      removeDialog: false,
      reportLoading: false,
      polling: null,
      operator: {},
      scanning: false,
      comparisonResultDialog: false,
      comparisonDisplay3Column: false,
      compareResults: [],
      comparisonResultTitle: '',
      comparisonResultItem: {},

      linkedChannels: [],
      newChannels: [],
      extraChannels: [],

      playerDialog: false,
      playerOperatorAssetId: 0,
      playerTitle: '',
      frameSrc: '',
      playerStream: '',

      distribChannels: [],
      channelMap: {},
      thirdPartyChannelMap: {},

      reassignTo: null,
      dataUpdating: false,
      logoConfirmDialog: false,
      newChLogo: '',
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded
    },
    isFormValid() {
      if (!(this.newDistribPack.name.length >= 3 && this.newDistribPack.name.length <= 255)) {
        return false
      }
      return true
    },
  },
  created() {
    this.scanOperator(this.$route.params.operator_id)
    this.pollData()
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  methods: {
    pollData() {
      // setTimeout(() => {
      // }, 1000)
      this.polling = setInterval(() => {
        if (this.operator.status === 'processing') {
          this.getOperatorById(this.operator.id)
        }
      }, 1000)
    },
    getOperatorById(id) {
      const data = {
        id,
        $expand: 'distribution_package',
      }
      const operatorReq = this.$store.dispatch('scOperator', data)
      return Promise.all([operatorReq])
        .then((res) => {
          if (!res.length) {
            this.$router.push({name: 'SotalCloudOperators'})
            return
          }

          this.operator = processSCOperator(res[0])

          if (this.operator.status === 'processing') {
            this.scanning = true
          }

          if (this.operator.status === 'scanned') {
            this.$store.commit('setPageLoader')

            this.$store.dispatch('getOperatorAssets', data)
              .then((result) => {
                var assets = result || []
                // console.log('assets', assets)
                var processed = assets.map((a) => processSCAsset(a))

                var excluded3pc = {}
                var excludedPlayoutCh = {}

                this.extraChannels = []
                this.linkedChannels = []

                for (let i = 0; i < processed.length; i += 1) {
                  var a = processed[i]

                  if (!a.scAsset.LCN) a.scAsset.LCN = ''

                  if (a.scAsset.ExtId && a.asset.ExtId) {
                    this.linkedChannels.push(a)
                    if (a.thirdPartyChannelId) {
                      excluded3pc[a.thirdPartyChannelId] = true
                    }
                    if (a.playoutChannelId) {
                      excludedPlayoutCh[a.playoutChannelId] = true
                    }
                    continue
                  }
                  if (a.scAsset.ExtId && !a.asset.ExtId) {
                    this.extraChannels.push(a)
                  }
                  if (!a.scAsset.ExtId && a.asset.ExtId) {
                    //this.newChannels.push(a)
                  }
                }

                this.scanning = false


                //if (this.operator.distributionPackage && this.operator.distributionPackage.id && !this.distribChannels.length) {
                if (this.operator.distributionPackage && this.operator.distributionPackage.id) {

                  const channelArgs = {
                    'suspended[eq]': 0,
                    $expand: 'instance',
                  }
                  const channelReq = this.$store.dispatch('channels', channelArgs)
                  const packChannelReq = this.$store.dispatch('distributionPackageChannels', this.operator.distributionPackage.id)
                  const thirdPartyChannelReq = this.$store.dispatch('thirdPartyChannels', {})

                  return Promise.all([channelReq, thirdPartyChannelReq, packChannelReq])
                    .then((res) => {
                      const channels = res[0] || []
                      const processed = []
                      for (let i = 0; i < channels.length; i += 1) {
                        const ch = channels[i]
                        const channel = {
                          id: ch.id,
                          name: ch.name,
                          instance: ch.instance.name,
                          external: false,
                          logoURL: ch.color_logo_url || ch.white_logo_url || '',
                        }
                        processed.push(channel)
                        this.channelMap[ch.id] = channel
                      }

                      const thirdPartyChannels = res[1] || []
                      const thirdPartyChannelsProcessed = thirdPartyChannels.map((ch) => processThirdPartyChannel(ch))
                      for (let i = 0; i < thirdPartyChannelsProcessed.length; i += 1) {
                        const ch = thirdPartyChannelsProcessed[i]
                        const channel = {
                          id: '3rd' + ch.id,
                          name: ch.name,
                          instance: ch.company,
                          external: true,
                          sourceURL: ch.url,
                          logoURL: ch.logoURL,
                        }
                        processed.push(channel)
                        this.thirdPartyChannelMap[ch.id] = channel
                      }

                      const packChannels = res[2] || []

                      const newChannels = []
                      this.distribChannels = []

                      for (let i = 0; i < packChannels.length; i += 1) {
                        const d = packChannels[i]

                        if (d.channel_id || d.third_party_channel_id) {
                          this.distribChannels.push(d)
                        }

                        // eslint-disable-next-line no-prototype-builtins
                        if (excludedPlayoutCh.hasOwnProperty(d.channel_id)) {
                          continue
                        }

                        // eslint-disable-next-line no-prototype-builtins
                        if (this.channelMap.hasOwnProperty(d.channel_id)) {
                          const ch = this.channelMap[d.channel_id]
                          let streamURL = ''
                          if (d.url) {
                            streamURL = d.url.replace('$origin', 'now')
                            streamURL = streamURL.replace('distrib010.noisypeak.com', 'distrib.noisypeak.com')
                            streamURL = streamURL.replace('$origin', 'now')
                            streamURL = streamURL.replace('$offset', '-1m_15s')
                            streamURL = streamURL.replace('now,-1m_15s', 'now_-1m_15s')
                            //streamURL = streamURL.replace(',', '_')
                          }
                          newChannels.push({
                            id: d.id,
                            channelId: ch.id,
                            channelName: ch.name,
                            instance: ch.instance,
                            url: streamURL,
                            external: false,
                            logoURL: ch.logoURL,
                          })
                        }

                        // eslint-disable-next-line no-prototype-builtins
                        if (excluded3pc.hasOwnProperty(d.third_party_channel_id)) {
                          continue
                        }

                        // eslint-disable-next-line no-prototype-builtins
                        if (this.thirdPartyChannelMap.hasOwnProperty(d.third_party_channel_id)) {
                          const ch = this.thirdPartyChannelMap[d.third_party_channel_id]
                          let streamURL = ''
                          if (d.url) {
                            streamURL = d.url.replace('distrib010.noisypeak.com', 'distrib.noisypeak.com')
                          }
                          newChannels.push({
                            id: d.id,
                            channelId: ch.id,
                            channelName: ch.name,
                            instance: ch.instance,
                            url: streamURL,
                            external: true,
                            sourceURL: ch.sourceURL,
                            logoURL: ch.logoURL,
                          })
                        }
                      }
                      this.newChannels = newChannels
                    })
                    .catch((errorMsg) => {
                      console.log('error', errorMsg)
                    })
                }

              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 6000,
                  color: 'error',
                })
              })
              .finally(() => this.$store.commit('resolvePageLoader'))
          }
        })
        .catch((errorMsg) => {
          this.$store.commit('showSnackbar', {
            text: errorMsg,
            timeout: 6000,
            color: 'error',
          })
        })
        .finally(() => this.$store.commit('resolvePageLoader'))
    },
    scanOperator(id) {
      // console.log('scan')
      this.scanning = true

      // this.$store.commit('setPageLoader')

      const data = {
        id,
      }
      const scanReq = this.$store.dispatch('scanOperator', data)

      this.operator.id = id
      this.operator.status = 'processing'

      /*        const channelArgs = {
    'suspended[eq]': 0,
    $expand: 'instance',
  }
  const channelReq = this.$store.dispatch('channels', channelArgs)

  const packChannelReq = this.$store.dispatch('distributionPackageChannels', id)

  const thirdPartyChannelArgs = {}
  const thirdPartyChannelReq = this.$store.dispatch('thirdPartyChannels', thirdPartyChannelArgs) */

      return Promise.all([scanReq])
        .then((res) => {
          // console.log('res', res)

          // this.getOperatorById(this.$route.params.operator_id)

          /*            const packages = res[0] || []
          if (!packages.length) {
            this.$router.push({ name: 'Distributions' })
            return
          }
          const pack = processDistributionPackage(packages[0])
          const fields = []
          for (let i = 0; i < pack.props.length; i += 1) {
            const prop = pack.props[i]
            if (prop.include) {
              const value = prop.auto ? '[[auto]]' : encodeURIComponent(prop.value)
              fields.push(prop.key + '=' + value)
            }
          }
          pack.propsStr = fields.join('&')
          this.distribPackage = pack

          const channels = res[1] || []
          const processed = []
          for (let i = 0; i < channels.length; i += 1) {
            const ch = channels[i]
            const channel = {
              id: ch.id,
              name: ch.name,
              instance: ch.instance.name,
              external: false,
            }
            processed.push(channel)
            this.channelMap[ch.id] = channel
          }

          const thirdPartyChannels = res[2] || []
          const thirdPartyChannelsProcessed = thirdPartyChannels.map((ch) => processThirdPartyChannel(ch))
          for (let i = 0; i < thirdPartyChannelsProcessed.length; i += 1) {
            const ch = thirdPartyChannelsProcessed[i]
            const channel = {
              id: '3rd' + ch.id,
              name: ch.name,
              instance: ch.company,
              external: true,
              sourceURL: ch.url,
            }
            processed.push(channel)
            this.thirdPartyChannelMap[ch.id] = channel
          }

          this.channels = processed

          const packChannels = res[3] || []
          this.processPackageChannels(packChannels) */
        })
        .catch((errorMsg) => {
          console.log('scan error', errorMsg)
        })
    },
    updateLCN(item) {
      let lcn = Number(item.scAsset.LCN)
      if (isNaN(lcn)) lcn = 0

      const data = {
        id: this.operator.id,
        asset_id: item.id,
        lcn: lcn,
      }
      this.patchOperatorAsset(data, false)
    },
    disableAsset(item) {
      const today = moment.utc().startOf('day')
      const yesterday = today.clone().subtract(1, 'days')
      const data = {
        id: this.operator.id,
        asset_id: item.id,
        rotation_finish: yesterday.format('YYYY-MM-DD') + 'T00:00:00Z',
      }
      item.scAsset.Status = 'innactive'
      this.patchOperatorAsset(data, false)
    },
    enableAsset(item) {
      const today = moment.utc().startOf('day')
      const rotEnd = today.clone().add(5, 'y')
      const data = {
        id: this.operator.id,
        asset_id: item.id,
        rotation_finish: rotEnd.format('YYYY-MM-DD') + 'T00:00:00Z',
      }
      item.scAsset.Status = ''
      this.patchOperatorAsset(data, false)
    },
    updateAssetCompareResult(field, data) {
      for (let i = 0; i < this.linkedChannels.length; i += 1) {
        const ch = this.linkedChannels[i]
        if (ch.id === data.asset_id) {

          const newCR = []
          for (let j = 0; j < ch.compareResult.length; j += 1) {
            if (ch.compareResult[j].field === field) {
              continue
            }
            newCR.push(ch.compareResult[j])
          }

          ch.compareResult = newCR
          break
        }
      }
    },
    updateAsset(field, newValue) {
      if (field === 'packages') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          package_id: 1,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'CDN Tag') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          cdn_tag: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'logo') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          logo_url: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'rating') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          rating: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'title') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          name: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'description') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          description: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'XMLTV URL') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          xmltv_url: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'genres') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          genres: newValue.split(','),
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'VAST ID') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          vast_id: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }

      if (field === 'provider') {
        const data = {
          id: this.operator.id,
          asset_id: this.comparisonResultItem.id,
          provider: newValue,
        }
        this.updateAssetCompareResult(field, data)
        this.patchOperatorAsset(data, false)
      }
    },
    patchOperatorCatchupURL(catchupURL) {
      const data = {
        id: this.operator.id,
        asset_id: this.comparisonResultItem.id,
        catchup_url: catchupURL,
      }
      this.patchOperatorAsset(data, true)
    },
    patchOperatorAsset(params, rescan) {
      this.dataUpdating = true
      this.comparisonResultDialog = false
      const patchReq = this.$store.dispatch('patchOperatorAsset', params)

      return Promise.all([patchReq])
        .then((res) => {
          this.$store.commit('showSnackbar', {
            text: 'The channel has been updated',
            timeout: 3000,
            color: 'success',
          })
          this.comparisonResultDialog = false
          if (rescan) {
            this.scanOperator(this.operator.id)
          }
        })
        .catch((errorMsg) => {
          console.log('patch error', errorMsg)
        })
        // eslint-disable-next-line no-return-assign
        .finally(() => {
          this.comparisonResultDialog = false
          this.dataUpdating = false
        })
    },
    addChannel(distrib) {
      this.dataUpdating = true

      const data = {
        id: this.operator.id,
        distrib_id: distrib.id,
      }

      const addReq = this.$store.dispatch('addChannelToSC', data)

      return Promise.all([addReq])
        .then((res) => {
          this.$store.commit('showSnackbar', {
            text: 'The channel has been added',
            timeout: 3000,
            color: 'success',
          })

          const index = this.newChannels.indexOf(distrib)
          this.newChannels.splice(index, 1)

          const channels = res || []
          if (channels.length) {
            var ch = processSCAsset(channels[0])
            this.linkedChannels.push(ch)
          }
        })
        .catch((errorMsg) => {
          console.log('patch error', errorMsg)
        })
        // eslint-disable-next-line no-return-assign
        .finally(() => {
          this.dataUpdating = false
        })
    },
    getDistributionPackages() {
      this.$store.commit('setPageLoader')

      const args = {}
      const distribPackReq = this.$store.dispatch('distributionPackages', args)

      const distribPackStatReq = this.$store.dispatch('distributionPackagesStat')

      return Promise.all([distribPackReq, distribPackStatReq])
        .then((res) => {
          const packages = res[0]
          const processed = packages.map((d) => processDistributionPackage(d))
          const index = {}
          for (let i = 0; i < processed.length; i += 1) {
            const parts = processed[i].mtPrefix.split('/')
            if (parts.length > 2) {
              processed[i].mtSuffix = parts[parts.length - 1] !== '' ? parts[parts.length - 1] : parts[parts.length - 2]
              processed[i].mtSuffix = '../' + processed[i].mtSuffix
              index[processed[i].id] = i
            }
          }

          const stat = res[1] || []
          for (let i = 0; i < stat.length; i += 1) {
            const s = stat[i]
            // eslint-disable-next-line no-prototype-builtins
            if (index.hasOwnProperty(s.DistributionPackageId)) {
              processed[index[s.DistributionPackageId]].playoutChannelCount = s.PlayoutChannelCount || 0
              processed[index[s.DistributionPackageId]].thirdPartyChannelCount = s.ThirdPartyChannelCount || 0
            }
          }

          this.distributionPackages = processed
        })
        .catch((errorMsg) => {
          this.$store.commit('showSnackbar', {
            text: errorMsg,
            timeout: 6000,
            color: 'error',
          })
          this.$router.push({name: 'ChannelsPage'})
        })
        .finally(() => this.$store.commit('resolvePageLoader'))
    },
    goToDetails(distribution) {
      this.$router.push({
        name: 'Distribution',
        params: {
          distribution_id: distribution.id,
        },
      })
    },
    openRemoveDialog(pack) {
      this.deletedDistribPack = pack
      this.removeDialog = true
    },
    deleteDistribPack() {
      if (!this.deletedDistribPack.id) return

      this.$store.commit('setPageLoader')
      this.$store.dispatch('deleteDistributionPackage', this.deletedDistribPack.id)
        .then(() => {
          this.$store.commit('showSnackbar', {
            text: 'The distribution package has been successfully removed',
            timeout: 6000,
            color: 'success',
          })
          this.getDistributionPackages()
          this.deletedDistribPack = {}
        })
        .catch((errorMsg) => {
          this.$store.commit('showSnackbar', {
            text: errorMsg,
            timeout: 6000,
            color: 'error',
          })
        })
        .finally(() => {
          this.removeDialog = false
          this.$store.commit('resolvePageLoader')
        })
    },
    exportXLS() {
      this.reportLoading = true
      this.$store.dispatch('exportAllDistributions')
        .then((response) => {
          const blob = new Blob([response.data], {type: response.data.type})
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'Playout Distributions'
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch((errorMsg) => {
          this.$store.commit('showSnackbar', {
            text: errorMsg,
            timeout: 6000,
            color: 'error',
          })
        })
        .finally(() => {
          this.reportLoading = false
        })
    },
    openComparisonResultDialog(item, thirdColumn) {
      this.comparisonResultItem = item
      this.comparisonResultTitle = item.name
      this.comparisonResultDialog = true
      this.comparisonDisplay3Column = thirdColumn
      this.compareResults = item.compareResult
    },
    checkPosters(compareResults) {
      for (let i = 0; i < compareResults.length; i += 1) {
        if (compareResults[i].field === 'logo') {
          return true
        }
      }

      return false
    },
    openPlayer(id, url, title) {
      this.setFrameSrc(url)
      this.reassignTo = null
      this.playerOperatorAssetId = id
      this.playerDialog = true
      this.playerTitle = title
      this.playerStream = url
    },
    setFrameSrc(url) {
      const link = url.replace(/^http:\/\//, 'https://')
      this.frameSrc = `/js/radiant/index.html?src=${link}`
    },
    closePlayer() {
      this.playerDialog = false
      this.playerTitle = ''
      this.playerStream = ''
      this.playerOperatorAssetId = 0
      this.setFrameSrc('')
    },
    reassign() {
      if (!this.reassignTo || !this.reassignTo.url) return

      const data = {
        id: this.operator.id,
        asset_id: this.playerOperatorAssetId,
        stream_url: this.reassignTo.url,
      }
      this.closePlayer()
      this.patchOperatorAsset(data, true)
    },
    openLogoDialog(newValue) {
      if (!newValue) return
      this.logoConfirmDialog = true
      this.newChLogo = newValue
    },
    updatePlayoutLogo() {
      if (this.comparisonResultItem.playoutChannelId > 0) {
        this.dataUpdating = true
        this.logoConfirmDialog = false

        const updated = {
          id: this.comparisonResultItem.playoutChannelId,
          color_logo_url: this.newChLogo,
        }

        const data = {
          asset_id: this.comparisonResultItem.id,
        }
        this.comparisonResultDialog = false
        this.updateAssetCompareResult('logo', data)

        this.$store.dispatch('updateChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.dataUpdating = false
            this.newChLogo = ''
          })
      }

      if (this.comparisonResultItem.thirdPartyChannelId > 0) {
        this.dataUpdating = true
        this.logoConfirmDialog = false

        const updated = {
          id: this.comparisonResultItem.thirdPartyChannelId,
          logo_url: this.newChLogo,
        }

        const data = {
          asset_id: this.comparisonResultItem.id,
        }
        this.comparisonResultDialog = false
        this.updateAssetCompareResult('logo', data)

        this.$store.dispatch('updateThirdPartyChannel', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.dataUpdating = false
            this.newChLogo = ''
          })
      }
    },
  },
}
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}

.compare-table {
  width: 100%;
}

.compare-table td {
  border-bottom: 1px solid #bbb;
  color: black;
  padding: 2px 2px;
}
</style>
